var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',{staticClass:"layout-container"},[_c('el-main',[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }